// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// export default function CandidateLogin({ onCandidateLogin }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);
//   const navigate = useNavigate();
//   const API =
//   process.env.REACT_APP_API_URL || "http://localhost:5000";

//   function isEmail(v) {
//     return typeof v === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
//   }

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setMessage(null);

//     if (!isEmail(email)) {
//       setMessage({ type: "danger", text: "Please enter a valid email address." });
//       return;
//     }
//     if (!password || password.length < 6) {
//       setMessage({ type: "danger", text: "Password must be at least 6 characters." });
//       return;
//     }

//     setLoading(true);
//     try {
//       const res = await axios.post(
//         `${API}/api/students/login`,
//         { email: email.trim().toLowerCase(), password },
//         { timeout: 30000 }
//       );

//       const token = res?.data?.token;
//       if (!token) {
//         const serverMsg = res?.data?.message || "Login failed — no token returned.";
//         setMessage({ type: "danger", text: serverMsg });
//         setLoading(false);
//         return;
//       }

//       localStorage.setItem("candidateToken", token);

//       try {
//         if (typeof onCandidateLogin === "function") onCandidateLogin(token);
//       } catch (err) {
//         console.warn("onCandidateLogin callback error:", err);
//       }

//       setMessage({ type: "success", text: "Login successful — redirecting to dashboard..." });

//       setTimeout(() => {
//         navigate("/candidate/dashboard");
//       }, 700);
//     } catch (err) {
//       console.error("candidate login error:", err);
//       const serverMsg =
//         err?.response?.data?.message ||
//         err?.response?.data?.error ||
//         err?.message ||
//         "Login failed. Please try again.";
//       setMessage({ type: "danger", text: serverMsg });
//     } finally {
//       setLoading(false);
//     }
//   }

//   return (
//     <div className="container my-5">
//       <div className="card shadow p-4 mx-auto" style={{ maxWidth: 480 }}>
//         <h2 className="mb-4 fw-bold text-center text-dark">Candidate Login</h2>

//         <form onSubmit={handleSubmit} noValidate>
//           <div className="mb-3">
//             <label className="form-label">Email</label>
//             <input
//               type="email"
//               className="form-control"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//               placeholder="registered email"
//               autoComplete="username"
//             />
//           </div>

//           <div className="mb-3">
//             <label className="form-label">Password</label>
//             <input
//               type="password"
//               className="form-control"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//               placeholder="your password"
//               autoComplete="current-password"
//             />
//           </div>

//           <button type="submit" className="btn btn-dark w-100 fw-bold" disabled={loading}>
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>

//         {message && (
//           <div
//             className={`alert mt-3 ${
//               message.type === "success" ? "alert-success" : "alert-danger"
//             }`}
//             role="alert"
//           >
//             {message.text}
//           </div>
//         )}

//         <div className="mt-3 text-center">
//           <a href="/set-password">Forgot / Setup Password?</a>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api"; // ✅ CHANGED

export default function CandidateLogin({ onCandidateLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const navigate = useNavigate();

  function isEmail(v) {
    return typeof v === "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setMessage(null);

    if (!isEmail(email)) {
      setMessage({ type: "danger", text: "Please enter a valid email address." });
      return;
    }

    if (!password || password.length < 6) {
      setMessage({ type: "danger", text: "Password must be at least 6 characters." });
      return;
    }

    setLoading(true);

    try {
      // ✅ CHANGED ONLY THIS LINE
      const res = await api.post("/api/students/login", {
        email: email.trim().toLowerCase(),
        password,
      });

      const token = res?.data?.token;

      if (!token) {
        const serverMsg =
          res?.data?.message || "Login failed — no token returned.";
        setMessage({ type: "danger", text: serverMsg });
        setLoading(false);
        return;
      }

      localStorage.setItem("candidateToken", token);

      try {
        if (typeof onCandidateLogin === "function") {
          onCandidateLogin(token);
        }
      } catch (err) {
        console.warn("onCandidateLogin callback error:", err);
      }

      setMessage({
        type: "success",
        text: "Login successful — redirecting to dashboard...",
      });

      setTimeout(() => {
        navigate("/candidate/dashboard");
      }, 700);

    } catch (err) {
      console.error("candidate login error:", err);

      const serverMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Login failed. Please try again.";

      setMessage({ type: "danger", text: serverMsg });

    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="container my-5">
      <div className="card shadow p-4 mx-auto" style={{ maxWidth: 480 }}>
        <h2 className="mb-4 fw-bold text-center text-dark">Candidate Login</h2>

        <form onSubmit={handleSubmit} noValidate>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="registered email"
              autoComplete="username"
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-dark w-100 fw-bold"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>

        </form>

        {message && (
          <div
            className={`alert mt-3 ${
              message.type === "success"
                ? "alert-success"
                : "alert-danger"
            }`}
            role="alert"
          >
            {message.text}
          </div>
        )}

        <div className="mt-3 text-center">
          <a href="/set-password">Forgot / Setup Password?</a>
        </div>
      </div>
    </div>
  );
}